export var ChargeTypology;
(function (ChargeTypology) {
    ChargeTypology["ExpertiseFees"] = "expertise-fees";
    ChargeTypology["RikFees"] = "rik-fees";
    ChargeTypology["OtherFees"] = "other-fees";
})(ChargeTypology || (ChargeTypology = {}));
